import React, { useState } from 'react'
import axios from 'axios'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import { Link } from 'react-router-dom'
import { isMobile } from '../../utils'
import { styles } from './styles'
import { useDeepEffect } from '../../utils/hooks'

export const UpdateEmail = (props) => {
  const [message, setmessage] = useState('')

  async function update() {
    const token = props.match.params.token
    try {
      const res = await axios.post(
        process.env.REACT_APP_API_ENDPOINT + `/hero/verifyUpdateEmail/` + token
      )
      const { data } = res
      console.log(data.message)
      setmessage(data.message)
    } catch (err) {
      console.log(err)
    }
  }

  useDeepEffect(() => {
    update()
  }, [])

  return (
    <main style={styles.main}>
      <Paper elevation={isMobile ? 0 : 1} square style={styles.paper}>
        <Typography id="titlePage" variant="h5">
          อัพเดทอีเมล
        </Typography>
        <div
          style={{
            marginTop: '1em'
          }}
        >
          <Typography component="p">{message}</Typography>
        </div>
        <div
          style={{
            marginTop: '1em'
          }}
        >
          <Button id="btnLogin" color="primary" fullWidth>
            <Link href="#" to="/" style={styles.link}>
              กลับสู่หน้าแรก
            </Link>
          </Button>
        </div>
      </Paper>
    </main>
  )
}

export default UpdateEmail



// WEBPACK FOOTER //
// ./src/pages/UpdateEmail/index.js